export enum AlertButtonType {
    Aceptar = 'Aceptar',
    Cancelar = 'Cancelar',
    Entendido = 'Entendido'
  }
  